import React from "react";
import OrderInfoSection from "./OrderInfoSection";
import CustomerInfoSection from "./CustomerInfoSection";
import ShippingInfoSection from "./ShippingInfoSection";
import StatusUpdateSection from "./StatusUpdateSection";

const OrderInfoGrid = ({ order, updating, onStatusUpdate }) => {
    return (
        <div className="order-details-grid">
            <OrderInfoSection order={order} />
            <CustomerInfoSection order={order} />
            <ShippingInfoSection order={order} />
            <StatusUpdateSection
                order={order}
                updating={updating}
                onStatusUpdate={onStatusUpdate}
            />
        </div>
    );
};

export default OrderInfoGrid;